import { cn } from 'utils/style-utils';

interface SkeletonBlockProps {
  className?: string;
}

/**
 * A pulsing block standing in for content that hasn't loaded yet. Carries no
 * size of its own — the caller shapes it with `className` to match whatever it
 * replaces.
 */
const SkeletonBlock = ({ className }: SkeletonBlockProps) => (
  <div className={cn('animate-pulse rounded-lg bg-neutral-300', className)} />
);

export default SkeletonBlock;
